<div
  [class.app-header--with-appcues-banner]="isAppcuesBannerVisible"
  class="app-header"
>
  <div class="app-header__logo">
    @if (isAsideEnabled) {
      <qima-button-icon
        qimaTooltip
        [qimaTooltipText]="tooltipMessage | translate"
        [qimaTooltipIsVisible]="true"
        [qimaTooltipHasArrow]="true"
        [qimaTooltipPosition]="tooltipPosition"
        [qimaButtonIconSize]="qimaButton.buttonSize.SMALL"
        [qimaButtonIconName]="qimaIcon.iconName.MENU"
        [qimaButtonIconStyle]="qimaButtonIcon.buttonIconStyle.TERTIARY_UTILITY"
        (qimaButtonIconClick)="onMenuClick()"
        data-cy="header-menu-button"
      >
      </qima-button-icon>
    }
    <img
      [src]="qimaLogo"
      alt="qima logo"
      class="qima-logo"
      role="button"
      tabindex="0"
      (click)="onQimaLogoClick()"
      (keydown.enter)="onQimaLogoClick()"
      (keydown.space)="$event.preventDefault(); onQimaLogoClick()"
      data-cy="header-qima-logo"
    />
    <span
      class="app-header__logo-text"
      data-cy="header-life-sciences-logo-text"
    >
      life sciences
    </span>
    @if (companyLogo) {
      <img
        [src]="companyLogo"
        alt="company logo"
        class="company-logo"
        data-cy="header-company-logo"
      />
    }
  </div>
  <div class="app-header__tool-bar">
    <ul>
      <li>
        <div class="app-header__tool-bar__buttons">
          <qima-button-icon
            cdkOverlayOrigin
            #menuTranslateOrigin="cdkOverlayOrigin"
            qimaTooltip
            [qimaTooltipPosition]="qimaTooltip.position.BOTTOM_RIGHT"
            [qimaTooltipText]="'APP_HEADER.ACCOUNT.LANGUAGE_SELECTOR_TIP' | translate"
            [qimaTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
            [qimaTooltipHasArrow]="true"
            [qimaTooltipStyle]="qimaTooltip.style.DARK"
            (qimaButtonIconClick)="openTranslate($event)"
            [qimaButtonIconSize]="qimaButton.buttonSize.SMALL"
            [qimaButtonIconName]="qimaIcon.iconName.LANGUAGE_WORLD"
            [qimaButtonIconStyle]="qimaButtonIcon.buttonIconStyle.TERTIARY_UTILITY"
            data-cy="header-language-button"
          >
          </qima-button-icon>
        </div>
      </li>
      <li class="app-header__tool-bar__divider">
        <qima-divider [qimaDividerOrientation]="qimaDivider.orientation.VERTICAL"></qima-divider>
      </li>
      <li>
        <div
          #menuProfileOrigin="cdkOverlayOrigin"
          cdkOverlayOrigin
          class="app-header__tool-bar__account"
          role="button"
          qimaTooltip
          [qimaTooltipPosition]="qimaTooltip.position.BOTTOM_RIGHT"
          [qimaTooltipText]="'APP_HEADER.ACCOUNT.PROFILE_TIP' | translate"
          [qimaTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
          [qimaTooltipHasArrow]="true"
          [qimaTooltipStyle]="qimaTooltip.style.DARK"
          [attr.aria-expanded]="isProfileMenuVisible"
          [attr.aria-haspopup]="true"
          tabindex="0"
          (click)="openProfile($event)"
          (keydown.enter)="openProfile($event)"
          (keydown.space)="$event.preventDefault(); openProfile($event)"
          [class.app-header__tool-bar__account--focus]="isProfileMenuVisible"
          data-cy="header-profile-button"
        >
          <qima-icon [qimaIconName]="qimaIcon.iconName.USER"></qima-icon>
        </div>
      </li>
    </ul>
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOffsetY]="8"
  [cdkConnectedOverlayWidth]="280"
  [cdkConnectedOverlayOrigin]="menuProfileOrigin"
  [cdkConnectedOverlayOpen]="isProfileMenuVisible"
  [cdkConnectedOverlayPanelClass]="'account-menu'"
  [cdkConnectedOverlayBackdropClass]="'header-backdrop'"
  [cdkConnectedOverlayHasBackdrop]="true"
  (overlayOutsideClick)="onProfileOverlayOutsideClick()"
  (detach)="onProfileOverlayDetach()"
>
  <app-account-menu data-cy="header-account-menu"></app-account-menu>
</ng-template>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOffsetY]="8"
  [cdkConnectedOverlayWidth]="180"
  [cdkConnectedOverlayOrigin]="menuTranslateOrigin"
  [cdkConnectedOverlayOpen]="isTranslateMenuVisible"
  [cdkConnectedOverlayBackdropClass]="'header-backdrop'"
  [cdkConnectedOverlayHasBackdrop]="true"
  (overlayOutsideClick)="onTranslateOverlayOutsideClick()"
  (detach)="onTranslateOverlayDetach()"
>
  <app-translate-menu data-cy="header-translate-menu"></app-translate-menu>
</ng-template>
